import { useEffect, useMemo, useState } from "react";

/**
 * Client-side pagination for filtered in-memory lists.
 */
export function useClientPagination(items, pageSize = 20) {
  const [page, setPage] = useState(1);

  const totalItems = items?.length || 0;
  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize) || 1);
  const safePage = Math.min(Math.max(1, page), totalPages);

  useEffect(() => {
    if (page !== safePage) setPage(safePage);
  }, [page, safePage]);

  const pageItems = useMemo(() => {
    const start = (safePage - 1) * pageSize;
    return (items || []).slice(start, start + pageSize);
  }, [items, safePage, pageSize]);

  const resetPage = () => setPage(1);

  return {
    page: safePage,
    setPage,
    resetPage,
    pageItems,
    totalItems,
    totalPages,
    pageSize,
  };
}

export default useClientPagination;
